import { FC } from 'react';
import Hero from 'src/categories/components/Hero';
import Categories from 'src/categories/components/Categories';
import ReviewAndAppLinks from 'src/common/components/ReviewAndAppLinks';
import SubFooter from 'src/common/components/SubFooter';
import FooterLinks from 'src/common/components/FooterLinks';
import Footer from 'src/common/components/Footer';

const CategoriesRoot: FC = () => (
  <main>
    <Hero />
    <Categories />
    <Footer>
      <FooterLinks />
      <ReviewAndAppLinks />
      <SubFooter />
    </Footer>
  </main>
);
export default CategoriesRoot;
